import { HoverCard, ScrollArea, Text } from '@mantine/core';
import React from 'react';

type Props = {
  comment?: string | null;
};

/**
 * Affichage du commentaire une fois la fin de mois validée.
 * Un Textarea désactivé n'est ni scrollable ni sélectionnable : le contenu
 * dépassant la hauteur de la cellule devenait inaccessible.
 */
export default function EndOfMonthCommentReadOnly({ comment }: Props) {
  if (!comment) {
    return null;
  }

  return (
    <HoverCard shadow="md" withArrow width={360} openDelay={200}>
      <HoverCard.Target>
        <Text
          size="xs"
          lineClamp={2}
          style={{ whiteSpace: 'pre-wrap', cursor: 'help' }}
        >
          {comment}
        </Text>
      </HoverCard.Target>
      <HoverCard.Dropdown>
        <ScrollArea.Autosize mah={280}>
          <Text size="xs" style={{ whiteSpace: 'pre-wrap' }}>
            {comment}
          </Text>
        </ScrollArea.Autosize>
      </HoverCard.Dropdown>
    </HoverCard>
  );
}
